import React from 'react'

// Common props shared across sofa elements
export interface SofaElementProps {
  id?: string
  width: number
  height: number
  x: number
  y: number
  draggable?: boolean
  verticalMetric?: boolean
  horizontalMetric?: boolean
  layer?: any | null // Konva Layer
  onDelete?: (() => void) | null
  showButtons?: boolean
  scale?: number
  stageWidth: number
  stageHeight: number
  currentRotation?: number
  originalSofaForm?: Record<string, any> | null
  armrestWidth?: number
  backrestWidth?: number
  mattressWidth?: number | null
  mattressLength?: number | null
  composition?: Array<{
    shape: string
    width: number
    height: number
    corner_part_length?: number
  }> | null
  armrestWidthOverride?: number | null
  rotation?: number
  cornerPartLength?: number
  cornerRadius?: number
  extendablePartLength?: number | null
  numberOfBigPillows?: number | null
  numberOfSmallPillows?: number | null
  spreadOfBigPillows?: number | null
  spreadOfSmallPillows?: number | null
  sizeOfBigPillow?: number | null
  sizeOfPillow?: number | null
  angle?: number | null
  seatSections?: number | null
  backrestSections?: number | null
  extensionType?: string | null
  backrestType?: string | null
  coveredSide?: boolean | null
}

interface ModuleExports {
  default: React.ComponentType<SofaElementProps>
  getDimensions: (params: {
    shapeWidth: number
    shapeHeight: number
    angle: number
    cornerRadius?: number
  }) => {
    armrestPosition: 'L' | 'R' | string
    connectors: Array<{
      x: number
      y: number
      type: 'left' | 'right'
      rotation: number
    }>
  }
  getDefaultSettings?: () => {
    dimensions: {
      width: number
      length: number
      armrestPosition: string
      corner_radius: number
    }
    changeableProperties: {
      width?: boolean
      height?: boolean
      length?: boolean
      seat_height?: boolean
      corner_radius?: boolean
      armrest_width?: boolean
      backrest_width?: boolean
    }
  }
}

export const loadSofaElement = async (
  type: string
): Promise<ModuleExports | undefined> => {
  try {
    // Use Vite's glob import to pre-bundle all possible sofa elements
    const modules = import.meta.glob<ModuleExports>(
      './SofaDrawingElements/SofaElements/*.tsx'
    )
    const modulePath = `./SofaDrawingElements/SofaElements/${type}.tsx`

    if (modulePath in modules) {
      const ShapeImport = await modules[modulePath]()
      if (
        ShapeImport.default
        //&& ShapeImport.getDimensions
      ) {
        return ShapeImport
      } else {
        console.error(`Module has no default export: ${modulePath}`)
        return undefined
      }
    } else {
      console.error(`Module not found: ${modulePath}`)
      console.log('Available modules:', Object.keys(modules))
      return undefined
    }
  } catch (error) {
    console.error('Error loading sofa element:', error)
    return undefined
  }
}
